module.exports = __webpack_public_path__ + "img/cc-cirrus.51b0294c.png";